module.exports = __webpack_public_path__ + "static/media/landingRight.97d53d22.png";